import { Menu } from "antd";
import React, { useEffect } from "react";
import { AiFillHome } from "react-icons/ai";
import { TbListCheck, TbReport } from "react-icons/tb";
import { HiOutlineBuildingOffice } from "react-icons/hi2";
import { CgClipboard } from "react-icons/cg";
import { SlSettings } from "react-icons/sl";
import { BsCreditCard, BsPerson, BsChatLeftTextFill } from "react-icons/bs";
import { AiOutlineFileDone, AiOutlineFileProtect } from "react-icons/ai";
import { MdOutlineMarkEmailUnread } from "react-icons/md";
import { ImExit, ImFileText } from "react-icons/im";
import { BiLogIn, BiChevronRight } from "react-icons/bi";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import { roles } from "../../config/roles";
// import { login } from "../../store/reducers/AuthSlice";
import "./sideMenu.css";
import openIcon from "../../assets/openIcon.png";
import useWindowDimensions from "../../hooks/useWindowDimensions";
import AuthAction from "../../store/Actions/AuthActions";
import { checkRouteName } from "../../utills";
import AuthMiddleware from "../../store/Middlewares/AuthMiddleware";
import { useTranslation } from "react-i18next";
function SideMenu({ collapsed, onBackClick }) {
  const dispatch = useDispatch();
  const navigation = useNavigate();
  const location = useLocation();
  const navigate = useNavigate();

  const { height, width } = useWindowDimensions();
  const { t, i18n } = useTranslation();
  const role = localStorage.getItem("role");
  const language = localStorage.getItem("i18nextLng");
  const logout = () => {
    dispatch(AuthMiddleware.Logout()).then((data) => {
      navigation("/");
    });

  };
  useEffect(() => {
    getLanguage();
  }, [])
  const getLanguage = async () => {
    try {
      const language = localStorage.getItem('@selectedLanguage');
      i18n.changeLanguage(language);
    } catch (e) {
      console.log(e);
    }
  };
  const menuStyle = {
    borderRadius: 0,
    width: "100%",
    margin: 0,
    padding: 0,
    paddingLeft: 0,
    marginBottom: 3,
  };
  // console.log("==============================", { height, width });
  const menu = [
    {
      style: menuStyle,
      key: "Home",
      icon: (
        <div
          className="active-menu-class"
          style={{ padding: "10px", borderRadius: 5 }}
        >
          <AiFillHome size={20} className="active-menu-class" />
        </div>
      ),
      label: <h4 className="menu-lable">{t("Home")}</h4>,
      onClick: () => {
        if (role == roles.contractor) {
          navigation("/contractorHome");
        } else if (role == roles.cleaner) {
          navigation("/cleanerHome");
        } else if (role == roles.customer) {
          navigation("/customerHome");
        }
      },
    },
    {
      style: menuStyle,
      key: 'Profile',
      icon: (
        <div
          className="active-menu-class"
          style={{ padding: "10px", borderRadius: 5 }}
        >
          <BsPerson size={20} className="active-menu-class" />
        </div>
      ),
      label: <h4 className="menu-lable">{t("Profile")}</h4>,
      onClick: () => {
        navigation('/profile')
      },
    },
    {
      style: menuStyle,
      key: 'Schedule',
      icon: (
        <div
          className="active-menu-class"
          style={{ padding: "10px", borderRadius: 5 }}
        >
          <AiOutlineFileDone size={20} className="active-menu-class" />
        </div>
      ),
      label: <h4 className="menu-lable">{t("Schedule")}</h4>,
      onClick: () => {
        if (role == roles.cleaner) {
          navigation('/schedule/Calendar')
        } else {
          navigation('/schedule')
        }
      },
    },
    {
      style: menuStyle,
      key: 'Company',
      icon: (
        <div
          className="active-menu-class"
          style={{ padding: "10px", borderRadius: 5 }}
        >
          <HiOutlineBuildingOffice size={20} className="active-menu-class" />
        </div>
      ),
      label: <h4 className="menu-lable">{t("Company")}</h4>,
      onClick: () => {
        navigation('/company')
      },
    },
    {
      style: menuStyle,
      key: 'Cleaners',
      icon: (
        <div
          className="active-menu-class"
          style={{ padding: "10px", borderRadius: 5 }}
        >
          <svg
            width="21"
            height="20"
            viewBox="0 0 21 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              className="active-menu-class"
              d="M8.20312 5.60305C8.27641 5.75373 9.10354 7.38693 10.8765 7.62797C11.8193 7.7396 12.7653 7.45016 13.5079 6.8229V4.97461C12.8389 5.2348 12.1481 5.4268 11.4449 5.54801C10.3724 5.73196 9.28059 5.75049 8.20312 5.60305Z"
              fill="#656565"
            />
            <path
              className="active-menu-class"
              d="M6.29232 4.51896H13.6132C13.7657 3.94686 13.7264 3.33624 13.5019 2.79155C13.0102 1.69786 11.6403 1.07544 10.1398 1.38281C8.56246 1.02521 7.09593 1.62072 6.51918 2.75935C6.26203 3.30293 6.18223 3.92193 6.29232 4.51896Z"
              fill="#656565"
            />
            <path
              className="active-menu-class"
              d="M11.0663 12.5264L10.583 13.2194L9.82663 13.7111L8.60527 12.9157L8.39515 12.6609L7.70056 13.1745L5.97461 13.9606V19.015H7.59562L7.57301 17.3808L12.0565 17.2909V19.2594L13.6144 19.015V13.869L11.0663 12.5264ZM8.07217 13.3322C8.07805 13.2204 8.26081 13.1192 8.39131 12.9803C8.7213 13.6169 9.1438 14.024 9.797 14.0303C10.4502 14.0365 10.8974 13.6712 11.1959 13.0522C11.5092 13.0834 11.6046 13.2444 11.5888 13.548C11.5662 14.001 11.5829 14.4561 11.5829 14.9418H8.05815C8.05815 14.4124 8.04074 13.8707 8.07217 13.3322Z"
              fill="#656565"
            />
            <path
              className="active-menu-class"
              d="M17.1681 10.1278C17.1798 9.79805 17.0491 9.6529 16.7338 9.65915C16.11 9.66949 15.4853 9.65603 14.8615 9.66324C14.6587 9.65579 14.4566 9.69315 14.2681 9.77296C14.0795 9.85277 13.9087 9.97329 13.7662 10.1269C13.6238 10.2805 13.5129 10.4638 13.4406 10.6653C13.3683 10.8668 13.3361 11.082 13.3461 11.2974C13.3423 11.9612 13.3461 12.624 13.3461 13.3401C12.7155 13.0436 12.1349 12.7775 11.5611 12.4947C11.4596 12.4226 11.3688 12.3346 11.292 12.2337C11.3621 12.1402 11.4426 12.0561 11.5317 11.9833C12.4411 11.4488 13.1381 10.5832 13.4945 9.54596C13.5184 9.44275 13.5697 9.349 13.6423 9.2759C13.715 9.20278 13.8058 9.15338 13.9041 9.13357C14.1042 9.08707 14.285 8.97372 14.42 8.81012C14.5551 8.64653 14.6373 8.44128 14.6546 8.22445C14.6894 8.00983 14.657 7.78898 14.5622 7.59585C14.4675 7.40273 14.3156 7.24802 14.13 7.15552C14.0546 7.11929 13.9927 7.05729 13.9543 6.97938C13.9158 6.90147 13.903 6.81213 13.9179 6.72559C13.9288 5.62012 13.9405 4.51465 13.9297 3.40919C13.9383 3.0739 13.856 2.74304 13.6927 2.45603C13.5293 2.16902 13.2917 1.93797 13.0082 1.79041C11.0493 0.702726 9.06798 0.588817 7.06495 1.67361C6.73222 1.83023 6.45212 2.09055 6.26176 2.42011C6.0714 2.74966 5.97976 3.13288 5.99899 3.51901C6.0069 4.59612 6.01481 5.67444 6.00577 6.75274C6.00351 6.82232 5.98736 6.89058 5.95839 6.95302C5.92942 7.01546 5.88829 7.07063 5.83772 7.1149C5.64924 7.21378 5.49436 7.37249 5.39455 7.56905C5.29474 7.76561 5.25493 7.99029 5.28064 8.21195C5.30813 8.44003 5.40016 8.65386 5.54455 8.82513C5.68894 8.9964 5.87888 9.11704 6.08923 9.17106C6.14715 9.19088 6.20081 9.22264 6.24716 9.26454C6.2935 9.30644 6.3316 9.35765 6.35928 9.41523C6.6839 10.4349 7.32329 11.3081 8.17368 11.8931C8.45459 12.0895 8.42902 12.3293 8.11758 12.4819C7.42887 12.8184 6.73631 13.1447 6.05077 13.485C5.10083 13.9568 4.43971 14.7291 4.31894 15.8365C4.23992 16.8986 4.215 17.9645 4.24429 19.0294C4.24226 19.2998 4.44378 19.3478 4.66182 19.3478C8.59127 19.3457 12.5207 19.3457 16.4502 19.3478C16.741 19.3478 16.8765 19.2277 16.8756 18.9095C16.8697 17.3344 16.8815 15.7613 16.8677 14.1853C16.8694 14.0023 16.8369 13.8207 16.772 13.6512C16.7072 13.4816 16.6113 13.3274 16.4899 13.1975C16.3686 13.0676 16.2242 12.9646 16.0651 12.8945C15.906 12.8243 15.7354 12.7884 15.5631 12.7888C15.3234 12.7785 15.0818 12.7867 14.843 12.7867V11.5351C15.4815 11.5351 16.0926 11.5257 16.7035 11.5392C17.0258 11.5464 17.1848 11.4243 17.1692 11.0643C17.1558 10.7528 17.1579 10.4397 17.1681 10.1278ZM13.3457 18.7014H12.4636C12.4636 18.2421 12.4557 17.7797 12.4665 17.3162C12.4753 16.9884 12.3534 16.8423 12.0352 16.8435C10.5537 16.8508 9.07235 16.8508 7.59104 16.8435C7.29542 16.8435 7.16673 16.9749 7.17261 17.2893C7.18144 17.7538 7.17466 18.2193 7.17466 18.7014H6.29256C6.29256 17.189 6.29053 15.7077 6.29844 14.2257C6.3026 14.1784 6.31679 14.1327 6.33994 14.092C6.36309 14.0513 6.3946 14.0168 6.43211 13.9909C6.75736 13.8186 7.09119 13.6684 7.46755 13.4877C7.46755 14.0733 7.47547 14.6035 7.46461 15.1336C7.45783 15.4655 7.58833 15.6013 7.90272 15.5991C9.17587 15.5919 10.449 15.5897 11.7222 15.5991C12.058 15.6022 12.182 15.453 12.1732 15.1064C12.1594 14.5907 12.1693 14.0731 12.1693 13.5002C12.5604 13.689 12.9042 13.8498 13.2412 14.0241C13.269 14.0435 13.2924 14.0694 13.3096 14.0997C13.3268 14.1301 13.3374 14.1642 13.3405 14.1995C13.3457 15.6952 13.3457 17.189 13.3457 18.7014ZM11.5833 14.9416H8.05833C8.05833 14.4129 8.04068 13.8707 8.07212 13.3315C8.078 13.2197 8.26075 13.1185 8.39148 12.9796C8.72147 13.6162 9.14398 14.0233 9.79718 14.0296C10.4504 14.0358 10.8973 13.6705 11.1961 13.0515C11.5093 13.0827 11.6048 13.2437 11.589 13.5473C11.5654 14.0012 11.5833 14.4561 11.5833 14.9416ZM9.73159 13.4052C9.61982 13.3961 9.51092 13.3631 9.41139 13.3084C9.31185 13.2536 9.2237 13.1781 9.1522 13.0863C9.0807 12.9946 9.02731 12.8885 8.9952 12.7744C8.96309 12.6603 8.95292 12.5405 8.9653 12.4221H10.6883C10.6616 13.0493 10.2522 13.4615 9.73159 13.4052ZM7.67857 2.05427C9.40544 1.24128 11.0843 1.43113 12.7223 2.33617C13.3658 2.69112 13.3902 3.32772 13.3273 4.01359H6.6083C6.5219 2.84012 6.70601 2.51256 7.67857 2.05427ZM6.93219 4.6699H12.9422C12.1872 5.41513 8.22683 5.54778 6.93219 4.6699ZM7.86833 5.80973C7.47049 5.95392 7.07355 6.0998 6.62436 6.2649V5.29834C7.02899 5.4382 7.43092 5.57807 7.83261 5.71793C7.84414 5.74797 7.85657 5.77849 7.86833 5.80973ZM13.3441 5.26277C13.3441 5.61772 13.3529 5.93566 13.3382 6.2512C13.3317 6.29381 13.3172 6.33459 13.2956 6.37116C13.274 6.40773 13.2457 6.43933 13.2124 6.46412C11.9167 7.43909 10.1591 7.44534 9.05894 6.22716C8.96847 6.12911 8.89789 6.01328 8.78593 5.86188C10.366 5.97555 11.8658 5.92773 13.3441 5.26277ZM6.88605 9.05595C6.79558 8.72816 6.7327 8.47654 6.31134 8.54143C6.18174 8.56234 5.9508 8.33163 5.88702 8.16461C5.84472 8.05407 6.00193 7.72507 6.09918 7.71065C6.58546 7.63855 6.63657 7.30043 6.60717 6.9289C7.19862 6.71069 7.73579 6.51146 8.31548 6.29734C9.67413 8.01633 11.3666 8.18648 13.186 7.24515C13.4014 7.37045 13.6058 7.51611 13.7967 7.68037C13.9224 7.80678 14.0907 8.05718 14.047 8.16365C13.9762 8.33475 13.7367 8.55297 13.5884 8.53735C13.2416 8.50082 13.1385 8.65751 13.0568 8.96007C12.9007 9.63362 12.5761 10.2498 12.1172 10.7433C11.6584 11.2368 11.0826 11.5892 10.4506 11.7634C10.0528 11.8782 9.6323 11.8688 9.23942 11.7362C8.66665 11.5358 8.15073 11.1851 7.73941 10.7165C7.32809 10.248 7.03443 9.67699 6.88605 9.05595ZM5.67826 18.6949H4.82851C4.82851 17.8672 4.81382 17.0749 4.83236 16.2838C4.84398 15.9405 4.92564 15.6041 5.0717 15.2977C5.21775 14.9913 5.42472 14.7223 5.67826 14.5093V18.6949ZM11.8601 18.7011H7.79301V17.4995H11.8599L11.8601 18.7011ZM16.2561 18.6949H13.9516V17.4914H16.2561V18.6949ZM16.2679 16.8264H13.9643V15.9372H16.2679V16.8264ZM15.5104 13.4139C15.6117 13.4075 15.7131 13.4236 15.8081 13.4612C15.9032 13.4989 15.9898 13.5572 16.0624 13.6325C16.1349 13.7077 16.1919 13.7983 16.2297 13.8983C16.2674 13.9984 16.285 14.1057 16.2815 14.2134C16.2912 14.4463 16.2844 14.6811 16.2844 14.9149V15.2552H13.9337V14.4622C13.9337 13.5792 13.9367 12.696 13.9317 11.8131C13.9317 11.6137 13.9523 11.4719 14.2273 11.5752C14.2273 12.0354 14.24 12.4759 14.2235 12.9155C14.2097 13.2913 14.3619 13.4343 14.7048 13.4134C14.9721 13.3987 15.2424 13.4045 15.5104 13.4139ZM16.5508 10.8857H13.995C14.0546 10.7165 14.16 10.5699 14.2979 10.4644C14.4359 10.3589 14.6002 10.2992 14.7701 10.2929C15.3537 10.2772 15.9381 10.2888 16.5511 10.2888L16.5508 10.8857Z"
              fill="#656565"
            />
            <path
              className="active-menu-class"
              d="M5.11714 8.9396C5.11714 8.47939 5.0563 8.41355 4.6329 8.41259C3.58072 8.41042 2.52764 8.41979 1.47569 8.40634C1.12806 8.40225 0.992349 8.54212 0.998229 8.91269C1.01203 9.82277 1.00321 10.7341 1.00321 11.6453C1.00321 13.0565 1.44629 13.6765 2.76739 14.0605C2.76739 15.5207 2.76535 16.9643 2.76942 18.4079C2.76942 18.6552 2.69184 19.0061 3.04853 19.0142C3.43846 19.0236 3.35206 18.6537 3.35296 18.3973C3.35794 16.9537 3.35499 15.5101 3.35499 14.0625C3.41877 14.0416 3.46401 14.025 3.50925 14.0125C4.61548 13.7025 5.11737 13.0084 5.11827 11.7893C5.11714 10.8393 5.11918 9.8891 5.11714 8.9396ZM4.52682 11.9654C4.518 12.8611 3.94419 13.4122 3.04356 13.41C2.17232 13.4078 1.60054 12.8484 1.59353 11.9681C1.58471 11.0068 1.59149 10.0456 1.59149 9.08428C1.63378 9.05496 1.67699 9.02588 1.72019 8.99656C1.77809 9.09268 1.88122 9.18545 1.8853 9.2835C1.90497 9.68651 1.86766 10.0924 1.90792 10.4923C1.92234 10.5777 1.95607 10.6582 2.00623 10.7267C2.05638 10.7953 2.12144 10.8498 2.19583 10.8857C2.41884 10.9285 2.48466 10.7124 2.48263 10.4923C2.47969 10.0893 2.47178 9.68555 2.49055 9.28254C2.4944 9.18641 2.59753 9.09773 2.65452 9.00593L2.77824 9.06553C2.75721 9.25555 2.76148 9.44777 2.79092 9.63652C2.82824 9.76702 2.97954 9.85978 3.07974 9.96961C3.17405 9.85474 3.31248 9.75572 3.3498 9.62403C3.37776 9.43826 3.38172 9.24931 3.36156 9.06241H4.50308C4.51611 9.15752 4.52434 9.2533 4.52773 9.34935C4.52977 10.2215 4.53564 11.0929 4.52682 11.9654Z"
              fill="#656565"
            />
            <path
              className="active-menu-class"
              d="M3.47551 0.0781439C2.99863 0.0897757 2.54483 0.298574 2.21057 0.66015C1.87631 1.02173 1.68795 1.50757 1.68555 2.01439C1.6921 2.52774 1.88902 3.01761 2.23353 3.37758C2.57804 3.73756 3.04232 3.93857 3.5255 3.93694C4.00228 3.92445 4.45575 3.71525 4.78987 3.35365C5.12398 2.99205 5.3125 2.50646 5.31547 1.99973C5.30927 1.48635 5.11243 0.996357 4.76782 0.636454C4.42321 0.276551 3.95872 0.0758831 3.47551 0.0781439ZM3.48231 3.31283C3.1551 3.30226 2.84494 3.15533 2.61886 2.90378C2.39278 2.65223 2.26892 2.31627 2.27406 1.96849C2.28694 1.62753 2.42378 1.30518 2.65579 1.06924C2.8878 0.833307 3.19689 0.702179 3.51803 0.70345C3.84527 0.713393 4.15564 0.860002 4.38182 1.11148C4.608 1.36296 4.73177 1.69903 4.72628 2.04683C4.71285 2.38767 4.57591 2.7098 4.34411 2.94584C4.11231 3.18187 3.80359 3.31355 3.48253 3.31331L3.48231 3.31283Z"
              fill="#656565"
            />
            <path
              className="active-menu-class"
              d="M16.1409 5.60254C15.8693 5.60404 15.6091 5.71891 15.4165 5.92239C15.2239 6.12587 15.1143 6.40165 15.1113 6.69022C15.1127 6.97862 15.2206 7.25491 15.4119 7.45953C15.6032 7.66416 15.8625 7.78074 16.1339 7.78414C16.4056 7.78296 16.6659 7.66818 16.8586 7.46463C17.0513 7.26109 17.1608 6.98513 17.1634 6.69646C17.1621 6.40806 17.0541 6.13177 16.8629 5.92715C16.6716 5.72252 16.4123 5.60594 16.1409 5.60254ZM16.1547 7.15355C16.0961 7.15792 16.0374 7.14949 15.982 7.1288C15.9266 7.1081 15.8758 7.07558 15.8327 7.03322C15.7897 6.99087 15.7552 6.93958 15.7315 6.88253C15.7078 6.82548 15.6953 6.76388 15.6949 6.70151C15.7263 6.4177 15.8638 6.23193 16.1389 6.23385C16.1976 6.22922 16.2565 6.23834 16.3115 6.26056C16.3666 6.28279 16.4163 6.31758 16.4573 6.36248C16.4983 6.40738 16.5295 6.4613 16.5487 6.52042C16.568 6.57954 16.5747 6.64243 16.5686 6.70464C16.5719 6.76373 16.5635 6.82289 16.544 6.87833C16.5245 6.93377 16.4942 6.98425 16.4552 7.02653C16.4163 7.06881 16.3694 7.10196 16.3176 7.12384C16.2659 7.14571 16.2103 7.15583 16.1547 7.15355Z"
              fill="#656565"
            />
            <path
              className="active-menu-class"
              d="M2.30979 4.04106C2.03838 4.0483 1.78051 4.16856 1.59177 4.37593C1.40303 4.58331 1.29854 4.86117 1.30082 5.14964C1.30757 5.43793 1.42056 5.71187 1.61547 5.91255C1.81038 6.11322 2.07165 6.22458 2.34305 6.22266C2.61472 6.21573 2.8729 6.09543 3.06173 5.88778C3.25055 5.68013 3.35484 5.40184 3.35203 5.11312C3.34562 4.8248 3.23271 4.55073 3.03769 4.35013C2.84268 4.14953 2.58121 4.03852 2.30979 4.04106ZM2.32066 5.59111C2.26502 5.59524 2.20917 5.58692 2.15674 5.56669C2.10431 5.54646 2.05646 5.51477 2.01628 5.47366C1.9761 5.43255 1.94448 5.38294 1.92347 5.32804C1.90246 5.27314 1.89253 5.21416 1.89431 5.15493C1.88052 4.86174 2.04946 4.70914 2.31273 4.66132C2.58098 4.6916 2.75785 4.83458 2.75875 5.12777C2.76378 5.19015 2.7559 5.25295 2.73563 5.31174C2.71536 5.37052 2.68322 5.42388 2.64145 5.46805C2.59969 5.51222 2.54932 5.54613 2.49389 5.56739C2.43847 5.58865 2.37934 5.59674 2.32066 5.59111Z"
              fill="#656565"
            />
            <path
              className="active-menu-class"
              d="M15.6982 1.8636C15.4442 1.9864 15.2881 2.49491 14.9694 2.15895C14.646 1.81794 15.1314 1.65596 15.2393 1.38488C15.1802 1.11717 14.6073 0.949671 14.9905 0.585109C15.2944 0.296727 15.4467 0.775678 15.6878 0.897519C15.9447 0.83023 16.1046 0.224628 16.4464 0.634371C16.7164 0.957599 16.2679 1.12006 16.1512 1.37311C16.2163 1.64851 16.7845 1.8189 16.4 2.18202C16.0965 2.4692 15.944 1.99169 15.6982 1.8636Z"
              fill="#656565"
            />
            <path
              className="active-menu-class"
              d="M8.78287 8.99735C9.04156 8.99735 9.25128 8.77452 9.25128 8.49965C9.25128 8.22478 9.04156 8.00195 8.78287 8.00195C8.52417 8.00195 8.31445 8.22478 8.31445 8.49965C8.31445 8.77452 8.52417 8.99735 8.78287 8.99735Z"
              fill="#656565"
            />
            <path
              className="active-menu-class"
              d="M11.1559 8.99735C11.4146 8.99735 11.6243 8.77452 11.6243 8.49965C11.6243 8.22478 11.4146 8.00195 11.1559 8.00195C10.8972 8.00195 10.6875 8.22478 10.6875 8.49965C10.6875 8.77452 10.8972 8.99735 11.1559 8.99735Z"
              fill="#656565"
            />
            <path
              className="active-menu-class"
              d="M4.7106 6.762C4.9693 6.762 5.17901 6.53917 5.17901 6.2643C5.17901 5.98943 4.9693 5.7666 4.7106 5.7666C4.4519 5.7666 4.24219 5.98943 4.24219 6.2643C4.24219 6.53917 4.4519 6.762 4.7106 6.762Z"
              fill="#656565"
            />
            <path
              className="active-menu-class"
              d="M17.1637 4.43583C17.4224 4.43583 17.6321 4.213 17.6321 3.93813C17.6321 3.66326 17.4224 3.44043 17.1637 3.44043C16.905 3.44043 16.6953 3.66326 16.6953 3.93813C16.6953 4.213 16.905 4.43583 17.1637 4.43583Z"
              fill="#656565"
            />
            <path
              className="active-menu-class"
              d="M19.3679 8.67347L18.3672 9.06722C18.1655 9.14659 18.0625 9.38468 18.1372 9.59901L18.1373 9.59924C18.212 9.81356 18.4361 9.92296 18.6378 9.84359L19.6385 9.44984C19.8402 9.37047 19.9432 9.13238 19.8685 8.91805L19.8684 8.91783C19.7937 8.7035 19.5696 8.5941 19.3679 8.67347Z"
              fill="#656565"
            />
            <path
              className="active-menu-class"
              d="M19.9466 10.121L18.8797 10.1397C18.6646 10.1434 18.4931 10.3317 18.4966 10.5603L18.4966 10.5605C18.5002 10.789 18.6774 10.9712 18.8925 10.9675L19.9594 10.9488C20.1745 10.945 20.346 10.7567 20.3425 10.5282L20.3425 10.528C20.3389 10.2995 20.1617 10.1173 19.9466 10.121Z"
              fill="#656565"
            />
            <path
              className="active-menu-class"
              d="M18.6294 7.2849L17.8549 8.06492C17.6988 8.22215 17.6922 8.48408 17.8402 8.64995L17.8404 8.65012C17.9883 8.816 18.2349 8.823 18.391 8.66577L19.1654 7.88576C19.3215 7.72853 19.3281 7.4666 19.1802 7.30073L19.18 7.30055C19.032 7.13468 18.7855 7.12767 18.6294 7.2849Z"
              fill="#656565"
            />
          </svg>
        </div>
      ),
      label: <h4 className="menu-lable">{t("Cleaners")}</h4>,
      onClick: () => {
        if (role == roles.customer) {
          navigate('/customerCleaner')
        } else {
          navigation('/Cleaners')
        }
      },
    },
    {
      style: menuStyle,
      key: 'Categories',
      icon: (
        <div
          className="active-menu-class"
          style={{ padding: "10px", borderRadius: 5 }}
        >
          {/* <AiOutlineFileDone size={20} className="active-menu-class" /> */}
          <svg
            width="19"
            height="18"
            viewBox="0 0 19 19"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              className="active-menu-class"
              d="M7.81445 0.193359H1.81445C1.54924 0.193359 1.29488 0.298716 1.10735 0.486253C0.91981 0.673789 0.814453 0.928143 0.814453 1.19336V7.19336C0.814453 7.45858 0.91981 7.71293 1.10735 7.90047C1.29488 8.088 1.54924 8.19336 1.81445 8.19336H7.81445C8.07967 8.19336 8.33402 8.088 8.52156 7.90047C8.7091 7.71293 8.81445 7.45858 8.81445 7.19336V1.19336C8.81445 0.928143 8.7091 0.673789 8.52156 0.486253C8.33402 0.298716 8.07967 0.193359 7.81445 0.193359ZM6.81445 6.19336H2.81445V2.19336H6.81445V6.19336ZM17.8145 10.1934H11.8145C11.5492 10.1934 11.2949 10.2987 11.1073 10.4863C10.9198 10.6738 10.8145 10.9281 10.8145 11.1934V17.1934C10.8145 17.4586 10.9198 17.7129 11.1073 17.9005C11.2949 18.088 11.5492 18.1934 11.8145 18.1934H17.8145C18.0797 18.1934 18.334 18.088 18.5216 17.9005C18.7091 17.7129 18.8145 17.4586 18.8145 17.1934V11.1934C18.8145 10.9281 18.7091 10.6738 18.5216 10.4863C18.334 10.2987 18.0797 10.1934 17.8145 10.1934ZM16.8145 16.1934H12.8145V12.1934H16.8145V16.1934ZM14.8145 0.193359C12.6085 0.193359 10.8145 1.98736 10.8145 4.19336C10.8145 6.39936 12.6085 8.19336 14.8145 8.19336C17.0205 8.19336 18.8145 6.39936 18.8145 4.19336C18.8145 1.98736 17.0205 0.193359 14.8145 0.193359ZM14.8145 6.19336C13.7115 6.19336 12.8145 5.29636 12.8145 4.19336C12.8145 3.09036 13.7115 2.19336 14.8145 2.19336C15.9175 2.19336 16.8145 3.09036 16.8145 4.19336C16.8145 5.29636 15.9175 6.19336 14.8145 6.19336ZM4.81445 10.1934C2.60845 10.1934 0.814453 11.9874 0.814453 14.1934C0.814453 16.3994 2.60845 18.1934 4.81445 18.1934C7.02045 18.1934 8.81445 16.3994 8.81445 14.1934C8.81445 11.9874 7.02045 10.1934 4.81445 10.1934ZM4.81445 16.1934C3.71145 16.1934 2.81445 15.2964 2.81445 14.1934C2.81445 13.0904 3.71145 12.1934 4.81445 12.1934C5.91745 12.1934 6.81445 13.0904 6.81445 14.1934C6.81445 15.2964 5.91745 16.1934 4.81445 16.1934Z"
              fill="#656565"
            />
          </svg>
        </div>
      ),
      label: <h4 className="menu-lable">{t("Category")}</h4>,
      onClick: () => {
        navigate("/categories");
      },
    },
    {
      style: menuStyle,
      key: 'Work Order Request',
      icon: (
        <div
          className="active-menu-class"
          style={{ padding: "10px", borderRadius: 5 }}
        >
          <CgClipboard size={20} className="active-menu-class" />
        </div>
      ),
      label: <> <h4 className="menu-lable" style={{ margin: 0, padding: 0, lineHeight: 1 }}>{t("Work Order Sidebar").slice(0, 19)}</h4>
        <h4 className="menu-lable" style={{ margin: 0, padding: 0, lineHeight: 1 }}>{t("Work Order Sidebar").slice(19, 50)} {role == roles.customer ? t('History') : null}</h4></>
      ,
      onClick: () => {
        if (role == roles.customer) {
          navigate('/WorkOrderRequest/WorkOrderList')
        } else {
          navigation('/WorkOrderRequest/Customers')
        }
      },
    },
    {
      style: menuStyle,
      key: 'Cleaner Task Summary',
      icon: (
        <div
          className="active-menu-class"
          style={{ padding: "10px", borderRadius: 5 }}
        >
          <TbListCheck size={20} className="active-menu-class" />
        </div>
      ),
      label: <> <h4 className="menu-lable" style={{ margin: 0, padding: 0, lineHeight: 1 }}>{t("Cleaner Task Summary").slice(0, 22)}</h4>
        <h4 className="menu-lable" style={{ margin: 0, padding: 0, lineHeight: 1 }}>{t("Cleaner Task Summary").slice(22, 50)}</h4></>,
      onClick: () => {
        navigate('/cleanerTaskSummary/Cleaners')
      },
    },
    {
      style: menuStyle,
      key: 'Subscription',
      icon: (
        <div
          className="active-menu-class"
          style={{ padding: "10px", borderRadius: 5 }}
        >
          <BsCreditCard size={20} className="active-menu-class" />
        </div>
      ),
      label: <h4 className="menu-lable">{t("Subscription")}</h4>,
      onClick: () => {
        navigation('/subscription')
      },
    },
    {
      style: menuStyle,
      key: 'Problem Report',
      icon: (
        <div
          className="active-menu-class"
          style={{ padding: "10px", borderRadius: 5 }}
        >
          <TbReport size={20} className="active-menu-class" />
        </div>
      ),
      label: <h4 className="menu-lable">{t("Problem Reporting")}</h4>,
      onClick: () => {
        navigate('/problemReport')
      },
    },
    {
      style: menuStyle,
      key: 'Contact Us',
      icon: (
        <div
          className="active-menu-class"
          style={{ padding: "10px", borderRadius: 5 }}
        >
          <MdOutlineMarkEmailUnread size={20} className="active-menu-class" />
        </div>
      ),
      label: <h4 className="menu-lable">{t("Contact Us")}</h4>,
      onClick: () => {
        navigation('/contactUs')
      },
    },
    {
      style: menuStyle,
      key: 'Terms And Services',
      icon: (
        <div
          className="active-menu-class"
          style={{ padding: "10px", borderRadius: 5 }}
        >
          <AiOutlineFileProtect size={20} className="active-menu-class" />
        </div>
      ),
      label: <h4 className="menu-lable">{t("Terms and service")}</h4>,
      onClick: () => {
        navigation('/termsAndServices')
      },
    },
    {
      style: menuStyle,
      key: 'Privacy Policy',
      icon: (
        <div
          className="active-menu-class"
          style={{ padding: "10px", borderRadius: 5 }}
        >
          <AiOutlineFileDone size={20} className="active-menu-class" />
        </div>
      ),
      label: <h4 className="menu-lable">{t("Privacy Policy")}</h4>,
      onClick: () => {
        navigation('/privacyPolicy')
      },
    },
    {
      style: menuStyle,
      key: 'Chat',
      icon: (
        <div
          className="active-menu-class"
          style={{ padding: "10px", borderRadius: 5 }}
        >
          <BsChatLeftTextFill size={20} className="active-menu-class" />
        </div>
      ),
      label: <h4 className="menu-lable">{t("Chat")}</h4>,
      onClick: () => {
        navigate("/chat/Inbox");
      },
    },
    {
      style: menuStyle,
      key: 'Settings',
      icon: (
        <div
          className="active-menu-class"
          style={{ padding: "10px", borderRadius: 5 }}
        >
          <SlSettings size={20} className="active-menu-class" />
        </div>
      ),
      label: <h4 className="menu-lable">{t("Settings")}</h4>,
      onClick: () => {
        navigate("/Settings");
      },
    },
  ];

  if (role == roles.cleaner) {
    menu.splice(3, 7, {
      style: menuStyle,
      key: "Jobs",
      icon: (
        <div
          className="active-menu-class"
          style={{ padding: "10px", borderRadius: 5 }}
        >
          <svg
            width="21"
            height="20"
            viewBox="0 0 21 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              className="active-menu-class"
              d="M8.20312 5.60305C8.27641 5.75373 9.10354 7.38693 10.8765 7.62797C11.8193 7.7396 12.7653 7.45016 13.5079 6.8229V4.97461C12.8389 5.2348 12.1481 5.4268 11.4449 5.54801C10.3724 5.73196 9.28059 5.75049 8.20312 5.60305Z"
              fill="#656565"
            />
            <path
              className="active-menu-class"
              d="M6.29232 4.51896H13.6132C13.7657 3.94686 13.7264 3.33624 13.5019 2.79155C13.0102 1.69786 11.6403 1.07544 10.1398 1.38281C8.56246 1.02521 7.09593 1.62072 6.51918 2.75935C6.26203 3.30293 6.18223 3.92193 6.29232 4.51896Z"
              fill="#656565"
            />
            <path
              className="active-menu-class"
              d="M11.0663 12.5264L10.583 13.2194L9.82663 13.7111L8.60527 12.9157L8.39515 12.6609L7.70056 13.1745L5.97461 13.9606V19.015H7.59562L7.57301 17.3808L12.0565 17.2909V19.2594L13.6144 19.015V13.869L11.0663 12.5264ZM8.07217 13.3322C8.07805 13.2204 8.26081 13.1192 8.39131 12.9803C8.7213 13.6169 9.1438 14.024 9.797 14.0303C10.4502 14.0365 10.8974 13.6712 11.1959 13.0522C11.5092 13.0834 11.6046 13.2444 11.5888 13.548C11.5662 14.001 11.5829 14.4561 11.5829 14.9418H8.05815C8.05815 14.4124 8.04074 13.8707 8.07217 13.3322Z"
              fill="#656565"
            />
            <path
              className="active-menu-class"
              d="M17.1681 10.1278C17.1798 9.79805 17.0491 9.6529 16.7338 9.65915C16.11 9.66949 15.4853 9.65603 14.8615 9.66324C14.6587 9.65579 14.4566 9.69315 14.2681 9.77296C14.0795 9.85277 13.9087 9.97329 13.7662 10.1269C13.6238 10.2805 13.5129 10.4638 13.4406 10.6653C13.3683 10.8668 13.3361 11.082 13.3461 11.2974C13.3423 11.9612 13.3461 12.624 13.3461 13.3401C12.7155 13.0436 12.1349 12.7775 11.5611 12.4947C11.4596 12.4226 11.3688 12.3346 11.292 12.2337C11.3621 12.1402 11.4426 12.0561 11.5317 11.9833C12.4411 11.4488 13.1381 10.5832 13.4945 9.54596C13.5184 9.44275 13.5697 9.349 13.6423 9.2759C13.715 9.20278 13.8058 9.15338 13.9041 9.13357C14.1042 9.08707 14.285 8.97372 14.42 8.81012C14.5551 8.64653 14.6373 8.44128 14.6546 8.22445C14.6894 8.00983 14.657 7.78898 14.5622 7.59585C14.4675 7.40273 14.3156 7.24802 14.13 7.15552C14.0546 7.11929 13.9927 7.05729 13.9543 6.97938C13.9158 6.90147 13.903 6.81213 13.9179 6.72559C13.9288 5.62012 13.9405 4.51465 13.9297 3.40919C13.9383 3.0739 13.856 2.74304 13.6927 2.45603C13.5293 2.16902 13.2917 1.93797 13.0082 1.79041C11.0493 0.702726 9.06798 0.588817 7.06495 1.67361C6.73222 1.83023 6.45212 2.09055 6.26176 2.42011C6.0714 2.74966 5.97976 3.13288 5.99899 3.51901C6.0069 4.59612 6.01481 5.67444 6.00577 6.75274C6.00351 6.82232 5.98736 6.89058 5.95839 6.95302C5.92942 7.01546 5.88829 7.07063 5.83772 7.1149C5.64924 7.21378 5.49436 7.37249 5.39455 7.56905C5.29474 7.76561 5.25493 7.99029 5.28064 8.21195C5.30813 8.44003 5.40016 8.65386 5.54455 8.82513C5.68894 8.9964 5.87888 9.11704 6.08923 9.17106C6.14715 9.19088 6.20081 9.22264 6.24716 9.26454C6.2935 9.30644 6.3316 9.35765 6.35928 9.41523C6.6839 10.4349 7.32329 11.3081 8.17368 11.8931C8.45459 12.0895 8.42902 12.3293 8.11758 12.4819C7.42887 12.8184 6.73631 13.1447 6.05077 13.485C5.10083 13.9568 4.43971 14.7291 4.31894 15.8365C4.23992 16.8986 4.215 17.9645 4.24429 19.0294C4.24226 19.2998 4.44378 19.3478 4.66182 19.3478C8.59127 19.3457 12.5207 19.3457 16.4502 19.3478C16.741 19.3478 16.8765 19.2277 16.8756 18.9095C16.8697 17.3344 16.8815 15.7613 16.8677 14.1853C16.8694 14.0023 16.8369 13.8207 16.772 13.6512C16.7072 13.4816 16.6113 13.3274 16.4899 13.1975C16.3686 13.0676 16.2242 12.9646 16.0651 12.8945C15.906 12.8243 15.7354 12.7884 15.5631 12.7888C15.3234 12.7785 15.0818 12.7867 14.843 12.7867V11.5351C15.4815 11.5351 16.0926 11.5257 16.7035 11.5392C17.0258 11.5464 17.1848 11.4243 17.1692 11.0643C17.1558 10.7528 17.1579 10.4397 17.1681 10.1278ZM13.3457 18.7014H12.4636C12.4636 18.2421 12.4557 17.7797 12.4665 17.3162C12.4753 16.9884 12.3534 16.8423 12.0352 16.8435C10.5537 16.8508 9.07235 16.8508 7.59104 16.8435C7.29542 16.8435 7.16673 16.9749 7.17261 17.2893C7.18144 17.7538 7.17466 18.2193 7.17466 18.7014H6.29256C6.29256 17.189 6.29053 15.7077 6.29844 14.2257C6.3026 14.1784 6.31679 14.1327 6.33994 14.092C6.36309 14.0513 6.3946 14.0168 6.43211 13.9909C6.75736 13.8186 7.09119 13.6684 7.46755 13.4877C7.46755 14.0733 7.47547 14.6035 7.46461 15.1336C7.45783 15.4655 7.58833 15.6013 7.90272 15.5991C9.17587 15.5919 10.449 15.5897 11.7222 15.5991C12.058 15.6022 12.182 15.453 12.1732 15.1064C12.1594 14.5907 12.1693 14.0731 12.1693 13.5002C12.5604 13.689 12.9042 13.8498 13.2412 14.0241C13.269 14.0435 13.2924 14.0694 13.3096 14.0997C13.3268 14.1301 13.3374 14.1642 13.3405 14.1995C13.3457 15.6952 13.3457 17.189 13.3457 18.7014ZM11.5833 14.9416H8.05833C8.05833 14.4129 8.04068 13.8707 8.07212 13.3315C8.078 13.2197 8.26075 13.1185 8.39148 12.9796C8.72147 13.6162 9.14398 14.0233 9.79718 14.0296C10.4504 14.0358 10.8973 13.6705 11.1961 13.0515C11.5093 13.0827 11.6048 13.2437 11.589 13.5473C11.5654 14.0012 11.5833 14.4561 11.5833 14.9416ZM9.73159 13.4052C9.61982 13.3961 9.51092 13.3631 9.41139 13.3084C9.31185 13.2536 9.2237 13.1781 9.1522 13.0863C9.0807 12.9946 9.02731 12.8885 8.9952 12.7744C8.96309 12.6603 8.95292 12.5405 8.9653 12.4221H10.6883C10.6616 13.0493 10.2522 13.4615 9.73159 13.4052ZM7.67857 2.05427C9.40544 1.24128 11.0843 1.43113 12.7223 2.33617C13.3658 2.69112 13.3902 3.32772 13.3273 4.01359H6.6083C6.5219 2.84012 6.70601 2.51256 7.67857 2.05427ZM6.93219 4.6699H12.9422C12.1872 5.41513 8.22683 5.54778 6.93219 4.6699ZM7.86833 5.80973C7.47049 5.95392 7.07355 6.0998 6.62436 6.2649V5.29834C7.02899 5.4382 7.43092 5.57807 7.83261 5.71793C7.84414 5.74797 7.85657 5.77849 7.86833 5.80973ZM13.3441 5.26277C13.3441 5.61772 13.3529 5.93566 13.3382 6.2512C13.3317 6.29381 13.3172 6.33459 13.2956 6.37116C13.274 6.40773 13.2457 6.43933 13.2124 6.46412C11.9167 7.43909 10.1591 7.44534 9.05894 6.22716C8.96847 6.12911 8.89789 6.01328 8.78593 5.86188C10.366 5.97555 11.8658 5.92773 13.3441 5.26277ZM6.88605 9.05595C6.79558 8.72816 6.7327 8.47654 6.31134 8.54143C6.18174 8.56234 5.9508 8.33163 5.88702 8.16461C5.84472 8.05407 6.00193 7.72507 6.09918 7.71065C6.58546 7.63855 6.63657 7.30043 6.60717 6.9289C7.19862 6.71069 7.73579 6.51146 8.31548 6.29734C9.67413 8.01633 11.3666 8.18648 13.186 7.24515C13.4014 7.37045 13.6058 7.51611 13.7967 7.68037C13.9224 7.80678 14.0907 8.05718 14.047 8.16365C13.9762 8.33475 13.7367 8.55297 13.5884 8.53735C13.2416 8.50082 13.1385 8.65751 13.0568 8.96007C12.9007 9.63362 12.5761 10.2498 12.1172 10.7433C11.6584 11.2368 11.0826 11.5892 10.4506 11.7634C10.0528 11.8782 9.6323 11.8688 9.23942 11.7362C8.66665 11.5358 8.15073 11.1851 7.73941 10.7165C7.32809 10.248 7.03443 9.67699 6.88605 9.05595ZM5.67826 18.6949H4.82851C4.82851 17.8672 4.81382 17.0749 4.83236 16.2838C4.84398 15.9405 4.92564 15.6041 5.0717 15.2977C5.21775 14.9913 5.42472 14.7223 5.67826 14.5093V18.6949ZM11.8601 18.7011H7.79301V17.4995H11.8599L11.8601 18.7011ZM16.2561 18.6949H13.9516V17.4914H16.2561V18.6949ZM16.2679 16.8264H13.9643V15.9372H16.2679V16.8264ZM15.5104 13.4139C15.6117 13.4075 15.7131 13.4236 15.8081 13.4612C15.9032 13.4989 15.9898 13.5572 16.0624 13.6325C16.1349 13.7077 16.1919 13.7983 16.2297 13.8983C16.2674 13.9984 16.285 14.1057 16.2815 14.2134C16.2912 14.4463 16.2844 14.6811 16.2844 14.9149V15.2552H13.9337V14.4622C13.9337 13.5792 13.9367 12.696 13.9317 11.8131C13.9317 11.6137 13.9523 11.4719 14.2273 11.5752C14.2273 12.0354 14.24 12.4759 14.2235 12.9155C14.2097 13.2913 14.3619 13.4343 14.7048 13.4134C14.9721 13.3987 15.2424 13.4045 15.5104 13.4139ZM16.5508 10.8857H13.995C14.0546 10.7165 14.16 10.5699 14.2979 10.4644C14.4359 10.3589 14.6002 10.2992 14.7701 10.2929C15.3537 10.2772 15.9381 10.2888 16.5511 10.2888L16.5508 10.8857Z"
              fill="#656565"
            />
            <path
              className="active-menu-class"
              d="M5.11714 8.9396C5.11714 8.47939 5.0563 8.41355 4.6329 8.41259C3.58072 8.41042 2.52764 8.41979 1.47569 8.40634C1.12806 8.40225 0.992349 8.54212 0.998229 8.91269C1.01203 9.82277 1.00321 10.7341 1.00321 11.6453C1.00321 13.0565 1.44629 13.6765 2.76739 14.0605C2.76739 15.5207 2.76535 16.9643 2.76942 18.4079C2.76942 18.6552 2.69184 19.0061 3.04853 19.0142C3.43846 19.0236 3.35206 18.6537 3.35296 18.3973C3.35794 16.9537 3.35499 15.5101 3.35499 14.0625C3.41877 14.0416 3.46401 14.025 3.50925 14.0125C4.61548 13.7025 5.11737 13.0084 5.11827 11.7893C5.11714 10.8393 5.11918 9.8891 5.11714 8.9396ZM4.52682 11.9654C4.518 12.8611 3.94419 13.4122 3.04356 13.41C2.17232 13.4078 1.60054 12.8484 1.59353 11.9681C1.58471 11.0068 1.59149 10.0456 1.59149 9.08428C1.63378 9.05496 1.67699 9.02588 1.72019 8.99656C1.77809 9.09268 1.88122 9.18545 1.8853 9.2835C1.90497 9.68651 1.86766 10.0924 1.90792 10.4923C1.92234 10.5777 1.95607 10.6582 2.00623 10.7267C2.05638 10.7953 2.12144 10.8498 2.19583 10.8857C2.41884 10.9285 2.48466 10.7124 2.48263 10.4923C2.47969 10.0893 2.47178 9.68555 2.49055 9.28254C2.4944 9.18641 2.59753 9.09773 2.65452 9.00593L2.77824 9.06553C2.75721 9.25555 2.76148 9.44777 2.79092 9.63652C2.82824 9.76702 2.97954 9.85978 3.07974 9.96961C3.17405 9.85474 3.31248 9.75572 3.3498 9.62403C3.37776 9.43826 3.38172 9.24931 3.36156 9.06241H4.50308C4.51611 9.15752 4.52434 9.2533 4.52773 9.34935C4.52977 10.2215 4.53564 11.0929 4.52682 11.9654Z"
              fill="#656565"
            />
            <path
              className="active-menu-class"
              d="M3.47551 0.0781439C2.99863 0.0897757 2.54483 0.298574 2.21057 0.66015C1.87631 1.02173 1.68795 1.50757 1.68555 2.01439C1.6921 2.52774 1.88902 3.01761 2.23353 3.37758C2.57804 3.73756 3.04232 3.93857 3.5255 3.93694C4.00228 3.92445 4.45575 3.71525 4.78987 3.35365C5.12398 2.99205 5.3125 2.50646 5.31547 1.99973C5.30927 1.48635 5.11243 0.996357 4.76782 0.636454C4.42321 0.276551 3.95872 0.0758831 3.47551 0.0781439ZM3.48231 3.31283C3.1551 3.30226 2.84494 3.15533 2.61886 2.90378C2.39278 2.65223 2.26892 2.31627 2.27406 1.96849C2.28694 1.62753 2.42378 1.30518 2.65579 1.06924C2.8878 0.833307 3.19689 0.702179 3.51803 0.70345C3.84527 0.713393 4.15564 0.860002 4.38182 1.11148C4.608 1.36296 4.73177 1.69903 4.72628 2.04683C4.71285 2.38767 4.57591 2.7098 4.34411 2.94584C4.11231 3.18187 3.80359 3.31355 3.48253 3.31331L3.48231 3.31283Z"
              fill="#656565"
            />
            <path
              className="active-menu-class"
              d="M16.1409 5.60254C15.8693 5.60404 15.6091 5.71891 15.4165 5.92239C15.2239 6.12587 15.1143 6.40165 15.1113 6.69022C15.1127 6.97862 15.2206 7.25491 15.4119 7.45953C15.6032 7.66416 15.8625 7.78074 16.1339 7.78414C16.4056 7.78296 16.6659 7.66818 16.8586 7.46463C17.0513 7.26109 17.1608 6.98513 17.1634 6.69646C17.1621 6.40806 17.0541 6.13177 16.8629 5.92715C16.6716 5.72252 16.4123 5.60594 16.1409 5.60254ZM16.1547 7.15355C16.0961 7.15792 16.0374 7.14949 15.982 7.1288C15.9266 7.1081 15.8758 7.07558 15.8327 7.03322C15.7897 6.99087 15.7552 6.93958 15.7315 6.88253C15.7078 6.82548 15.6953 6.76388 15.6949 6.70151C15.7263 6.4177 15.8638 6.23193 16.1389 6.23385C16.1976 6.22922 16.2565 6.23834 16.3115 6.26056C16.3666 6.28279 16.4163 6.31758 16.4573 6.36248C16.4983 6.40738 16.5295 6.4613 16.5487 6.52042C16.568 6.57954 16.5747 6.64243 16.5686 6.70464C16.5719 6.76373 16.5635 6.82289 16.544 6.87833C16.5245 6.93377 16.4942 6.98425 16.4552 7.02653C16.4163 7.06881 16.3694 7.10196 16.3176 7.12384C16.2659 7.14571 16.2103 7.15583 16.1547 7.15355Z"
              fill="#656565"
            />
            <path
              className="active-menu-class"
              d="M2.30979 4.04106C2.03838 4.0483 1.78051 4.16856 1.59177 4.37593C1.40303 4.58331 1.29854 4.86117 1.30082 5.14964C1.30757 5.43793 1.42056 5.71187 1.61547 5.91255C1.81038 6.11322 2.07165 6.22458 2.34305 6.22266C2.61472 6.21573 2.8729 6.09543 3.06173 5.88778C3.25055 5.68013 3.35484 5.40184 3.35203 5.11312C3.34562 4.8248 3.23271 4.55073 3.03769 4.35013C2.84268 4.14953 2.58121 4.03852 2.30979 4.04106ZM2.32066 5.59111C2.26502 5.59524 2.20917 5.58692 2.15674 5.56669C2.10431 5.54646 2.05646 5.51477 2.01628 5.47366C1.9761 5.43255 1.94448 5.38294 1.92347 5.32804C1.90246 5.27314 1.89253 5.21416 1.89431 5.15493C1.88052 4.86174 2.04946 4.70914 2.31273 4.66132C2.58098 4.6916 2.75785 4.83458 2.75875 5.12777C2.76378 5.19015 2.7559 5.25295 2.73563 5.31174C2.71536 5.37052 2.68322 5.42388 2.64145 5.46805C2.59969 5.51222 2.54932 5.54613 2.49389 5.56739C2.43847 5.58865 2.37934 5.59674 2.32066 5.59111Z"
              fill="#656565"
            />
            <path
              className="active-menu-class"
              d="M15.6982 1.8636C15.4442 1.9864 15.2881 2.49491 14.9694 2.15895C14.646 1.81794 15.1314 1.65596 15.2393 1.38488C15.1802 1.11717 14.6073 0.949671 14.9905 0.585109C15.2944 0.296727 15.4467 0.775678 15.6878 0.897519C15.9447 0.83023 16.1046 0.224628 16.4464 0.634371C16.7164 0.957599 16.2679 1.12006 16.1512 1.37311C16.2163 1.64851 16.7845 1.8189 16.4 2.18202C16.0965 2.4692 15.944 1.99169 15.6982 1.8636Z"
              fill="#656565"
            />
            <path
              className="active-menu-class"
              d="M8.78287 8.99735C9.04156 8.99735 9.25128 8.77452 9.25128 8.49965C9.25128 8.22478 9.04156 8.00195 8.78287 8.00195C8.52417 8.00195 8.31445 8.22478 8.31445 8.49965C8.31445 8.77452 8.52417 8.99735 8.78287 8.99735Z"
              fill="#656565"
            />
            <path
              className="active-menu-class"
              d="M11.1559 8.99735C11.4146 8.99735 11.6243 8.77452 11.6243 8.49965C11.6243 8.22478 11.4146 8.00195 11.1559 8.00195C10.8972 8.00195 10.6875 8.22478 10.6875 8.49965C10.6875 8.77452 10.8972 8.99735 11.1559 8.99735Z"
              fill="#656565"
            />
            <path
              className="active-menu-class"
              d="M4.7106 6.762C4.9693 6.762 5.17901 6.53917 5.17901 6.2643C5.17901 5.98943 4.9693 5.7666 4.7106 5.7666C4.4519 5.7666 4.24219 5.98943 4.24219 6.2643C4.24219 6.53917 4.4519 6.762 4.7106 6.762Z"
              fill="#656565"
            />
            <path
              className="active-menu-class"
              d="M17.1637 4.43583C17.4224 4.43583 17.6321 4.213 17.6321 3.93813C17.6321 3.66326 17.4224 3.44043 17.1637 3.44043C16.905 3.44043 16.6953 3.66326 16.6953 3.93813C16.6953 4.213 16.905 4.43583 17.1637 4.43583Z"
              fill="#656565"
            />
            <path
              className="active-menu-class"
              d="M19.3679 8.67347L18.3672 9.06722C18.1655 9.14659 18.0625 9.38468 18.1372 9.59901L18.1373 9.59924C18.212 9.81356 18.4361 9.92296 18.6378 9.84359L19.6385 9.44984C19.8402 9.37047 19.9432 9.13238 19.8685 8.91805L19.8684 8.91783C19.7937 8.7035 19.5696 8.5941 19.3679 8.67347Z"
              fill="#656565"
            />
            <path
              className="active-menu-class"
              d="M19.9466 10.121L18.8797 10.1397C18.6646 10.1434 18.4931 10.3317 18.4966 10.5603L18.4966 10.5605C18.5002 10.789 18.6774 10.9712 18.8925 10.9675L19.9594 10.9488C20.1745 10.945 20.346 10.7567 20.3425 10.5282L20.3425 10.528C20.3389 10.2995 20.1617 10.1173 19.9466 10.121Z"
              fill="#656565"
            />
            <path
              className="active-menu-class"
              d="M18.6294 7.2849L17.8549 8.06492C17.6988 8.22215 17.6922 8.48408 17.8402 8.64995L17.8404 8.65012C17.9883 8.816 18.2349 8.823 18.391 8.66577L19.1654 7.88576C19.3215 7.72853 19.3281 7.4666 19.1802 7.30073L19.18 7.30055C19.032 7.13468 18.7855 7.12767 18.6294 7.2849Z"
              fill="#656565"
            />
          </svg>
        </div>
      ),
      label: <h4 className="menu-lable">{t("Jobs")}</h4>,
      onClick: () => {
        navigation("/jobs");
      },
    });
  }

  if (role == roles.customer) {
    menu.splice(3, 1);
    menu.splice(4, 1);
    menu.splice(6, 2,
      {
        style: menuStyle,
        key: 'Work Order Request Form',
        icon: (
          <div
            className="active-menu-class"
            style={{ padding: "10px", borderRadius: 5 }}
          >
            <ImFileText size={20} className="active-menu-class" />
          </div>
        ),
        label: <> <h4 className="menu-lable" style={{ margin: 0, padding: 0, lineHeight: 1 }}>{t("Work Order Sidebar").slice(0, 19)}</h4>
          <h4 className="menu-lable" style={{ margin: 0, padding: 0, lineHeight: 1 }}>{t("Work Order Sidebar").slice(19, 50)} {role == roles.customer ? t('Form') : null}</h4></>
        ,
        onClick: () => {
          navigation('WorkOrderRequestForm')
        },
      });
  }
  return (
    <>
      <div className="logo_container">
        {!collapsed ? (
          <img
            src={require("../../assets/sidebarOpenLogo.png")}
            alt="logo"
            style={{ width: "80%", height: "80%" }}
          />
        ) : (
          <img
            src={require("../../assets/sidebarCloseLogo.png")}
            alt="logo"
            style={{ width: "80%", height: "80%" }}
          />
        )}
      </div>
      <Menu
        style={
          collapsed
            ? {
              backgroundColor: "var(--dark-grey)",
              width: "54%",
              marginLeft: 21,
              padding: "20px 0px",
              borderRadius: 5,
            }
            : {
              backgroundColor: "var(--primary-color)",
              width: "90%",
              marginLeft: 15,
            }
        }
        mode="inline"
        defaultSelectedKeys={location.pathname}
        selectedKeys={checkRouteName(location.pathname?.substring(1))}
        items={menu}
      />
      {!collapsed ? (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            marginTop: 50,
            paddingBottom: 40,
            cursor: "pointer",
          }}
          className="menu-logout"
          onClick={logout}
        >
          <BiLogIn size={40} className="logoutIcon" />
          {width > 768 && <h3>{t("Logout")}</h3>}
        </div>
      ) : (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            marginTop: 100,
            paddingBottom: 40,
            cursor: "pointer",
          }}
          onClick={logout}
        >
          <BiLogIn size={40} className="logoutIcon" />
        </div>
      )}
    </>
  );
}

export default SideMenu;
